export const DEFAULT_ORIENTATION_CODE = "Std";

export const MANDATORY_OPTION = "TRUE";
export const NON_MANDATORY_OPTION = "FALSE";
